export enum PhotoStudioGenerationStepId {
  START_PROCESSING = 'start_processing',
  UPLOADING_MASK = 'uploading_mask',
  MASK_UPLOADED = 'mask_uploaded',
  UPLOAD_MASK = 'upload_mask',
  ERASING_OBJECT = 'erasing_object',
  FETCHING_RESULT = 'fetching_result',
  PROCESSING_COMPLETE = 'processing_complete',
  FINALIZING = 'finalizing',
}
